<div class="container-expanded footer-border-top pt--24 pb--24">
    <div class="container text-center pt--16 pb--16">
        <div class="text-muted mb-0 ">
            Delfi.ai © All rights reserved <a class="pl--8 pr--8" href="https://www.maregroup.it/" target="_blank">Mare Group S.p.A.</a> <small>P.IVA IT 07784980638</small>
        </div>
        <small>
            <a href="/privacy-policy-delfi" target="_blank" aria-label="Leggi la Privacy Policy">Privacy
                Policy</a>&nbsp; - &nbsp;<a href="/termini-e-condizioni-delfi" target="_blank"
                aria-label="Leggi i Termini e le Condizioni">Termini e Condizioni</a></small>
    </div>
</div>